(function () {
  const header = document.getElementById('main-header');
  if (!header) return;

  const bar = header.querySelector('[data-bar]');
  const spacer = document.getElementById('header-spacer');
  const isHome = header.getAttribute('data-is-home') === 'true';

  // Keep spacer equal to header height (fixes white gap jump)
  function syncHeights() {
    const h = bar.getBoundingClientRect().height || 72;
    header.style.setProperty('--bar-h', h + 'px');
    if (spacer) spacer.style.height = h + 'px';
  }

  syncHeights();
  let resizeTO;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTO);
    resizeTO = setTimeout(syncHeights, 120);
  });

  // Other pages: solid white sticky header
  if (!isHome) {
    header.classList.remove('header-bottom-initial');
    header.classList.add('header-is-sticky', 'header-standard-page');
    bar.style.setProperty('--slide-y', '0px');
    return;
  }

  // Homepage: start bottom, slide up smoothly
  header.classList.add('header-bottom-initial');
  header.classList.remove('header-is-sticky');

  function startY() {
  const h = bar.getBoundingClientRect().height || 72;
  const offset = 100; // how many px ABOVE the bottom you want
  return Math.max(
    0,
    (window.innerHeight || document.documentElement.clientHeight) - h - offset
  );
}


  // Initialize starting position
  bar.style.setProperty('--slide-y', startY() + 'px');

  let ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => {
      const sY = startY();
      const y = Math.max(0, sY - window.scrollY);
      const slide = Math.min(sY, y);
      bar.style.setProperty('--slide-y', slide + 'px');
      ticking = false;
    });
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('load', () => {
    syncHeights();
    bar.style.setProperty('--slide-y', startY() + 'px');
    onScroll();
  });
})();
/* ==========================================
   MOBILE MENU TOGGLE
   ========================================== */
document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.querySelector('.mobile-menu-toggle');
  const drawer = document.querySelector('.mobile-menu-drawer');
  const closeBtns = drawer ? drawer.querySelectorAll('[data-close], .mobile-menu-close') : [];
  const backdrop = drawer ? drawer.querySelector('.mobile-menu-backdrop') : null;

  function openDrawer() {
    drawer.classList.add('is-open');
    toggle?.setAttribute('aria-expanded', 'true');
    drawer?.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    drawer.classList.remove('is-open');
    toggle?.setAttribute('aria-expanded', 'false');
    drawer?.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  toggle?.addEventListener('click', () => {
    if (!drawer) return;
    drawer.classList.contains('is-open') ? closeDrawer() : openDrawer();
  });

  closeBtns.forEach(btn => btn.addEventListener('click', closeDrawer));
  backdrop?.addEventListener('click', closeDrawer);

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeDrawer();
  });
});
/* MOBILE SAFE TOP GUARD: set once, no cumulative padding */
(function () {
  function setSafeTopVar() {
    // Fallback of 12 if env not supported
    const el = document.documentElement;
    // Read current CSS var or compute a fallback
    const fallback = 12;
    // Try to read iOS safe area via CSS env using a probe element
    // If not available, stick to fallback
    el.style.setProperty('--safe-top', `${fallback}px`);
  }

  setSafeTopVar();
  window.addEventListener('resize', setSafeTopVar);
  window.addEventListener('orientationchange', setSafeTopVar);
})();
